import { AppController } from "controllers/AppController";
import { useEffect, useRef } from "react";

export function useHeaderElement() {
  const controller = AppController.use();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    controller.actionAddHeaderElement(el);
    return () => controller.actionRemoveHeaderElement(el);
  }, [ref.current]);

  return ref;
}
